import { menuDefault } from "@/config";

const common = {
  state: {
    menuDefault: menuDefault,
    newUserCount: 0,
    newAlarmCount: 0,
    warnCount: 0,
    newConsultCount: 0,
  },
  mutations: {
    NEW_USER(state, count) {
      state.newUserCount = count;
    },
    NEW_ALARM(state, count) {
      state.newAlarmCount = count;
    },
    WORN(state, count) {
      state.warnCount = count;
    },
    NEW_CONSULT(state, count) {
      state.newConsultCount = count;
    }
  },
};
export default common;
